// John Eldhose 20190405
const LMDCache = (lmdcache) => ({
  type: 'LMDCache',
  lmdcache
});

export default LMDCache;



// WEBPACK FOOTER //
// ./src/actions/LMDCache.js